import { render } from "./HowCanHelp.vue?vue&type=template&id=e197ca10"
import script from "./HowCanHelp.vue?vue&type=script&lang=js"
export * from "./HowCanHelp.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__